import { createAction } from 'redux-actions';
import types from './types';

export const setCategories = createAction(types.CATEGORIES);
export const setSubcategories = createAction(types.SUB_CATEGORIES);
export const setSearch = createAction(types.SEARCH);
export const setPublishedDates = createAction(types.PUBLISHED_DATES);
export const setDocumentTypes = createAction(types.DOCUMENT_TYPES);
export const setDocumentSources = createAction(types.DOCUMENT_SOURCES);
export const setMunicipality = createAction(types.MUNICIPALITY);
export const setSort = createAction(types.SORT);
export const pageNumber = createAction(types.PAGE_NUMBER);
export const setOrder = createAction(types.TABLE_ORDER);
export const setLanguage = createAction(types.SET_LANGUAGE);




// WEBPACK FOOTER //
// ./src/filters/actions.js